export const objExcept = (obj, keys) => {
    const response = { ...obj };
    keys.forEach((key) => delete response[key]);
    return response;
};
